export default __webpack_public_path__ + "static/media/Bottom_home_selected.951b98d2.svg";